var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            id: "app",
            visible: _vm.innerVisible,
            "close-on-click-modal": false,
            title: _vm.title,
            "inline-message": "",
            width: _vm.$selectByLang(
              "1000px",
              "1200px",
              "1200px",
              "1500px",
              "1500px",
              "1400px"
            )
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "schemeMaintainForm",
              attrs: {
                model: _vm.schemeMaintainForm,
                disabled: _vm.locked,
                "label-width": _vm.isZh ? "80px" : "100px",
                "label-position": "left"
              }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 7, sm: 7, md: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_BusinessType")
                          }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: {
                                no: "BusinessType",
                                filterable: "",
                                placeholder: _vm.$t("common.defaultPlaceholder")
                              },
                              on: { change: _vm.lobChangeHandler },
                              model: {
                                value: _vm.schemeMaintainForm.lob,
                                callback: function($$v) {
                                  _vm.$set(_vm.schemeMaintainForm, "lob", $$v)
                                },
                                expression: "schemeMaintainForm.lob"
                              }
                            },
                            _vm._l(_vm.lobArray, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName,
                                  value: item.code
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 7, sm: 7, md: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_ProductName") }
                        },
                        [
                          _c("el-input", {
                            directives: [
                              { name: "uppercase", rawName: "v-uppercase" }
                            ],
                            attrs: { no: "ProductName" },
                            model: {
                              value: _vm.schemeMaintainForm.name,
                              callback: function($$v) {
                                _vm.$set(_vm.schemeMaintainForm, "name", $$v)
                              },
                              expression: "schemeMaintainForm.name"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 8, sm: 8, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_Department") }
                        },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "departmentRef",
                              attrs: { no: "Department", multiple: "" },
                              on: { change: _vm.changeDepartment },
                              model: {
                                value: _vm.schemeMaintainForm.departmentIdArr,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.schemeMaintainForm,
                                    "departmentIdArr",
                                    $$v
                                  )
                                },
                                expression: "schemeMaintainForm.departmentIdArr"
                              }
                            },
                            _vm._l(_vm.allDepartments, function(item) {
                              return _c("el-option", {
                                key: item.departmentId,
                                attrs: {
                                  value: item.departmentId,
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "InverseSelect" },
                      on: { click: _vm.departmentReverseSelect }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_InverseSelect")))]
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 7, sm: 7, md: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_TypeOfGoods") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "TypeOfGoods",
                              filterable: "",
                              clearable: false,
                              "select-type":
                                _vm.selectTypeNames.basic_data_CargoType,
                              "callback-params": { key: "cargoType" },
                              "callback-method-type": "value",
                              "default-value": _vm.schemeMaintainForm.cargoType
                            },
                            on: {
                              parentCallBack:
                                _vm.getSchemeMaintainValueFromChild
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 7, sm: 7, md: 7 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_FLCLType") } },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "FLclRef",
                              attrs: { no: "FLCLType", multiple: "" },
                              on: { change: _vm.changeFLCL },
                              model: {
                                value:
                                  _vm.schemeMaintainForm.containerLoadTypeArr,
                                callback: function($$v) {
                                  _vm.$set(
                                    _vm.schemeMaintainForm,
                                    "containerLoadTypeArr",
                                    $$v
                                  )
                                },
                                expression:
                                  "schemeMaintainForm.containerLoadTypeArr"
                              }
                            },
                            _vm._l(_vm.containerLoadTypes, function(item) {
                              return _c("el-option", {
                                key: item.code,
                                attrs: {
                                  value: item.code,
                                  label: _vm.isZh
                                    ? item.chineseName
                                    : item.englishName
                                }
                              })
                            }),
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 8, sm: 8, md: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_DescriptionOfPlan")
                          }
                        },
                        [
                          _c("el-input", {
                            attrs: { no: "PlanDescription" },
                            model: {
                              value: _vm.schemeMaintainForm.remark,
                              callback: function($$v) {
                                _vm.$set(_vm.schemeMaintainForm, "remark", $$v)
                              },
                              expression: "schemeMaintainForm.remark"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { xs: 7, sm: 7, md: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_EffectiveDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "EffectiveDate",
                              type: "date",
                              placeholder:
                                _vm.$t("CargoMsg.Cargo_Select") +
                                _vm.$t("CargoMsg.Cargo_EffectiveDate")
                            },
                            model: {
                              value: _vm.schemeMaintainForm.effectiveDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.schemeMaintainForm,
                                  "effectiveDate",
                                  $$v
                                )
                              },
                              expression: "schemeMaintainForm.effectiveDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { xs: 7, sm: 7, md: 7 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("CargoMsg.Cargo_InvalidDate") }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "InvalidDate",
                              type: "date",
                              placeholder:
                                _vm.$t("CargoMsg.Cargo_Select") +
                                _vm.$t("CargoMsg.Cargo_InvalidDate")
                            },
                            model: {
                              value: _vm.schemeMaintainForm.expiryDate,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.schemeMaintainForm,
                                  "expiryDate",
                                  $$v
                                )
                              },
                              expression: "schemeMaintainForm.expiryDate"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm.innerVisible
                ? _c(
                    "el-tabs",
                    {
                      staticStyle: { width: "100%" },
                      attrs: { type: "card" },
                      model: {
                        value: _vm.activeTabName,
                        callback: function($$v) {
                          _vm.activeTabName = $$v
                        },
                        expression: "activeTabName"
                      }
                    },
                    [
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_ChargeDetails"),
                            name: "dgSchemeDetail"
                          }
                        },
                        [
                          _c("de-scheme-detail", {
                            ref: "deSchemeDetail",
                            attrs: {
                              "dg-scheme-detail-value": _vm.dgSchemeDetailValue,
                              lob: _vm.schemeMaintainForm.lob,
                              status: _vm.innerStatus,
                              locked: _vm.locked,
                              "city-list-old": _vm.cityList,
                              "sale-role-hide": _vm.saleRoleHide
                            },
                            on: { func: _vm.getDataFormDgSchemeDetail }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_PortOfLoading"),
                            name: "polGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "pol-group",
                            attrs: {
                              "detail-value": _vm.polDetailValue,
                              status: _vm.innerStatus,
                              lob: _vm.schemeMaintainForm.lob,
                              "is-need-change-port": _vm.isNeedChangePort,
                              "group-name": "POL",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormPolGroup }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_DestinationPort"),
                            name: "podGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "pod-group",
                            attrs: {
                              "detail-value": _vm.podDetailValue,
                              status: _vm.innerStatus,
                              lob: _vm.schemeMaintainForm.lob,
                              "is-need-change-port": _vm.isNeedChangePort,
                              "group-name": "POD",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormPodGroup }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_OverseaWarehouse"),
                            name: "owGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "ow-group",
                            attrs: {
                              "detail-value": _vm.owDetailValue,
                              status: _vm.status,
                              "group-name": "OVERSEA-WAREHOUSE",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormOwGroup }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_HSCode"),
                            name: "hsCodeGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "hs-code-group",
                            attrs: {
                              "detail-value": _vm.hsCodeDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "HSCODE",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormHsCode }
                          })
                        ],
                        1
                      ),
                      !_vm.saleRoleHide
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                lazy: true,
                                label: _vm.$t(
                                  "CargoMsg.Cargo_AuthorizedClient"
                                ),
                                name: "customerGroup"
                              }
                            },
                            [
                              _c("group-tab", {
                                ref: "customer-group",
                                attrs: {
                                  "detail-value": _vm.customerDetailValue,
                                  status: _vm.innerStatus,
                                  "group-name": "CUSTOMER",
                                  locked: _vm.locked
                                },
                                on: { func: _vm.getDataFormCustomer }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_Carrier"),
                            name: "carrierGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "carrier-group",
                            attrs: {
                              "detail-value": _vm.carrierDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "CARRIER",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormCarrier }
                          })
                        ],
                        1
                      ),
                      !_vm.saleRoleHide
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                lazy: true,
                                label: _vm.$t("CargoMsg.Cargo_BookingAgent"),
                                name: "bookingAgentGroup"
                              }
                            },
                            [
                              _c("group-tab", {
                                ref: "booking-agent-group",
                                attrs: {
                                  "detail-value": _vm.bookingAgentDetailValue,
                                  status: _vm.innerStatus,
                                  "group-name": "BOOKING-AGENT",
                                  locked: _vm.locked
                                },
                                on: { func: _vm.getDataFormBookingAgent }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.saleRoleHide
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                lazy: true,
                                label: _vm.$t("SeaExport.BillExchangeAgent"),
                                name: "exchangeAgentGroup"
                              }
                            },
                            [
                              _c("group-tab", {
                                ref: "exchange-agent-group",
                                attrs: {
                                  "detail-value": _vm.exchangeAgentDetailValue,
                                  status: _vm.innerStatus,
                                  "group-name": "EXCHANGE-AGENT",
                                  locked: _vm.locked
                                },
                                on: { func: _vm.getDataFormExchangeAgent }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      !_vm.saleRoleHide
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                lazy: true,
                                label: _vm.$t("CargoMsg.Cargo_NominatedAgent"),
                                name: "designationAgentGroup"
                              }
                            },
                            [
                              _c("group-tab", {
                                ref: "designation-agent-group",
                                attrs: {
                                  "detail-value":
                                    _vm.designationAgentDetailValue,
                                  status: _vm.innerStatus,
                                  "group-name": "DESIGNATION-AGENT",
                                  locked: _vm.locked
                                },
                                on: { func: _vm.getDataFormDesignationAgent }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_ShippingRouteArea"),
                            name: "saGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "sa-group",
                            attrs: {
                              "detail-value": _vm.saDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "SA",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormSa }
                          })
                        ],
                        1
                      ),
                      !_vm.saleRoleHide
                        ? _c(
                            "el-tab-pane",
                            {
                              attrs: {
                                lazy: true,
                                label: _vm.$t(
                                  "CargoMsg.Cargo_DestinationAgent"
                                ),
                                name: "destinationAgentGroup"
                              }
                            },
                            [
                              _c("group-tab", {
                                ref: "destination-agent-group",
                                attrs: {
                                  "detail-value":
                                    _vm.destinationAgentDetailValue,
                                  status: _vm.innerStatus,
                                  "group-name": "DESTINATION-AGENT",
                                  locked: _vm.locked
                                },
                                on: { func: _vm.getDataFormDestinationAgent }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_AvailableBranch"),
                            name: "branchGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "branch-group",
                            attrs: {
                              "detail-value": _vm.branchDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "BRANCH",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormBranchCode }
                          })
                        ],
                        1
                      ),
                      _c(
                        "el-tab-pane",
                        {
                          attrs: {
                            lazy: true,
                            label: _vm.$t("CargoMsg.Cargo_User"),
                            name: "userGroup"
                          }
                        },
                        [
                          _c("group-tab", {
                            ref: "user-group",
                            attrs: {
                              "detail-value": _vm.userDetailValue,
                              status: _vm.innerStatus,
                              "group-name": "USER",
                              locked: _vm.locked
                            },
                            on: { func: _vm.getDataFormUserCode }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          ),
          _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
            _c(
              "span",
              { staticStyle: { position: "absolute", left: "20px" } },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.isNew,
                        expression: "!isNew"
                      }
                    ],
                    attrs: {
                      no: "CopyAndAddPoItems",
                      disabled: _vm.locked,
                      type: "primary"
                    },
                    on: { click: _vm.copyHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_CopyAndAddPoItems")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "ExportExpenses", type: "primary" },
                    on: { click: _vm.exportHandler }
                  },
                  [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_ExportExpenses")))]
                )
              ],
              1
            ),
            _c(
              "span",
              { staticStyle: { "padding-right": "5px" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: {
                      no: "confirm",
                      disabled: _vm.locked,
                      type: "primary"
                    },
                    on: { click: _vm.submitCostPlan }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
                ),
                _c(
                  "el-button",
                  {
                    attrs: { no: "cancel" },
                    on: {
                      click: function($event) {
                        _vm.innerVisible = false
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("business-copy-window", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.copyDialog.visible,
            expression: "copyDialog.visible"
          }
        ],
        ref: "costPlanCopyWindow",
        attrs: { source: "COST_PLAN", visible: _vm.copyDialog.visible },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.copyDialog, "visible", $event)
          },
          confirmCallBack: _vm.copyDialog.confirmCallBackHandler
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }